import {ChangeDetectionStrategy, Component, model,ViewChild, ModelSignal, OnDestroy, OnInit, OutputRefSubscription, AfterViewInit} from '@angular/core';
import { MenuCommonComponent } from '@app/shared/menu-common/menu-common.component';
import { Partner } from '@app/shared/_models/common';
import { DatePipe, NgClass, DecimalPipe } from '@angular/common';
import {FormControl, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {LiveAnnouncer} from '@angular/cdk/a11y';
import { RouterLink } from '@angular/router';
import {SelectDateComponent} from '@app/shared/select-date/select-date.component';


import { Subject, BehaviorSubject, Observable, pipe, Subscription,combineLatest, map } from 'rxjs';


import {MatCardModule} from '@angular/material/card';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {provideNativeDateAdapter} from '@angular/material/core';
import {MatTableDataSource, MatTableModule} from '@angular/material/table';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {MatSort, Sort, MatSortModule} from '@angular/material/sort';
import {MatDividerModule} from '@angular/material/divider';


import { ValuesService } from '@app/common/values/values.service';

import { LogisticService, DeliveryPlanning } from '../logistic.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SpinnerService } from '@app/shared/spinner.service';
import { AlertService } from '@app/shared/alert.service';
import * as constants from "@app/shared/constants";

@Component({
    selector: 'app-planning',
    imports: [SelectDateComponent, MenuCommonComponent, RouterLink, MatDividerModule, MatSortModule, MatSort, FormsModule, MatButtonModule, MatIconModule, MatTableModule, MatInputModule, MatFormFieldModule, MatDatepickerModule],
    templateUrl: './planning.component.html',
    styleUrl: './planning.component.scss',
		changeDetection: ChangeDetectionStrategy.Eager,
		standalone: true,
})
export class PlanningComponent implements OnInit, OnDestroy, AfterViewInit {
	// public displayedColumns: string[] = ['id', 'p_name', 'purchasePrice', 'salesPrice_taxx', 'salesPrice_taxi', 'margin', 'marginrate', 'marqrate'];
	// public displayedColumns: string[] = ['id','name','city', 'sort','products',];
	public displayedColumns: string[] = ['id','client','city','slot' ,  'products' ];

  public dataSource: MatTableDataSource<any>  = new MatTableDataSource( );
  public dateSelected = model<Date>(new Date());
  public date:Date = new Date();
  public deliveries: DeliveryPlanning[] = [];
  public opAndSlots! : any;
  public mouseoverSubject: Subject<number> = new Subject();
	public mouseoutSubject: BehaviorSubject<boolean> = new BehaviorSubject(false);
  deliveryOpAndSlot$!: Observable<any>; 
  deliveryOpAndSlotSubscription!:Subscription; 
  // public date = new FormControl(new Date());
  
  

  constructor(private valuesService: ValuesService, private _liveAnnouncer : LiveAnnouncer , private logisticService: LogisticService, private router: Router, private route: ActivatedRoute, private spinner: SpinnerService, private alertService: AlertService) { }

  ngOnInit(): void {
    this.deliveryOpAndSlotSubscription = combineLatest({op:this.valuesService.getValues$(constants.C_VALUES_DELIVERY_OPERATOR), slot:this.valuesService.getValues$(constants.C_VALUES_DELIVERY_SLOT)  })
    .subscribe(opAndSlots => { 
      this.opAndSlots = opAndSlots; 
      console.log('opAndSlots',opAndSlots);
      this.getDeliveries(this.date);
    } )
    
  }

  @ViewChild(MatSort)  sort!: MatSort;

  ngAfterViewInit() {
    // this.dataSource.sort = this.sort;
  }

  update(){ // never call
    console.log(' salut from qsdf');
    this.dataSource.sort = this.sort;
  }

  dateChange(dat :Date):void {
    console.log('dat',dat);
    this.date = dat
    this.getDeliveries(dat);
  }

  variationDate(nbrJour : number):void {
    this.date = new Date (this.date.setDate(this.date.getDate() + nbrJour) );
    this.getDeliveries(this.date);
  }

  announceSortChange(sortState: Sort) {
    console.log(' salut from announceSortChange');
    // This example uses English messages. If your application supports
    // multiple language, you would internationalize these strings.
    // Furthermore, you can customize the message to add additional
    // details about the values being sorted.
    if (sortState.direction) {
      this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
    } else {
      this._liveAnnouncer.announce('Sorting cleared');
    }
  }


  getDeliveries(date : Date): void {
    this.logisticService.getPlanedDeliveriesByDate(date)
    .subscribe({
      next: (deliveries: DeliveryPlanning[]) => {
        console.log('deliveries',deliveries);
        this.deliveries = deliveries.filter((delivery) => delivery.lnk_order?.lnk_customer && delivery.lnk_order.lnk_customer.id && Partner.addresses(delivery.lnk_order.lnk_customer).length && delivery.lnk_order.addr_deliv && delivery.id > 0);
        console.log('deliveries', this.deliveries );
        
        this.dataSource = new MatTableDataSource(this.deliveriesToDataSource(this.deliveries));
        this.dataSource.sort = this.sort;
        console.log('this.sort',this.sort);
        // this.dataSource.filterPredicate = (order: any, filter: string) => !filter || order.lnk_customer.firstname === filter;
      },
      error: (e) => {
        console.log("ERREUR Serveur : ", e.error);
        this.spinner.hide();
        this.alertService.error("ERREUR Serveur : " + e.error);	
      }});
    }

    // La ville de livraison : l'adresse addr_deliv de la commande parmi les lignes de rôle -5 du
    // client (c_partner_partner). Vide si le client n'a pas d'adresse chargée.
    deliveryCity(order: any): string {
      const adresses = Partner.addresses(order?.lnk_customer);
      return adresses.length ? (this.findElementById(adresses as any, order.addr_deliv)?.city ?? '') : '';
    }

    // l'idée ici est de créer un objet complètement applati et avec les chaine de caractère compilé tel qu'elle seront affiché aucun traitement coté vue l'interet est que le moteur de recherche natif fonctionnera sur ce que l on voit.
    deliveriesToDataSource(deliveries: DeliveryPlanning[]): any[] {
      console.log('deliveries', deliveries);
      let result: any[] = [];
      for (const delivery of deliveries) {
        const order = delivery.lnk_order;
        result.push({
          id: order.id,
          client: order.lnk_customer ? ((order.lnk_customer.firstname ?? '') + ' ' + (order.lnk_customer.name ?? '')) : '',
          city: Partner.addresses(order.lnk_customer).length ? this.findElementById(Partner.addresses(order.lnk_customer), order.addr_deliv).city : '',
          products: (order.lines ?? []).map((line) => line.qty + '  ' + line.product_name),
          slot: this.getOpAndSlot(delivery),
        });
      }
      return result;
    }




    findElementById(arrayElmts : any[] , id : number) : any {
      // console.log('id',id);
      // console.log('arrayElmts.find( (elt) =>( elt.id === id) )',arrayElmts.find( (elt) =>( elt.id === id) ));
      return arrayElmts.find( (elt) =>( elt.id === id) );
    }

    getOpAndSlot( lnkDelivery: any ) : string {
      if (!lnkDelivery || !lnkDelivery.mode || lnkDelivery.mode === 3) return 'Livraison dès que possible'
      let retour =''
      if(lnkDelivery.askop) {
        retour = (this.opAndSlots && this.opAndSlots.op ) ? this.opAndSlots.op.find((op :any) => op.id == lnkDelivery.askop)?.name + ' '  : ''; 
      }
      if (lnkDelivery.askslot) {
        retour += (this.opAndSlots && this.opAndSlots.slot ) ? this.opAndSlots.slot.find((slot :any) => slot.id == lnkDelivery.askslot)?.name : ''
        retour = retour.replace(' Matin',' de matinée')
        retour = retour.replace(' Après-midi',' d\'après-midi')
      }
      if ( !retour )  retour = new DatePipe  (navigator.language || 'fr-FR').transform(lnkDelivery.askdatdel,'dd/MM') +' '
      return retour;
    }

    applyFilter(event: Event) {
      const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
      this.dataSource.filter = filterValue;
    }

    onClickRow(row: any, _e: Event): void {
      this.router.navigate(['/sales/quotation/' + row.id]);	// Jump to partner only in standalone mode (not in dialog)
    }
    
    onMouseOver(row: any) {
      //console.log("Over row: " +row.id);
      this.mouseoutSubject.next(true);
      this.mouseoverSubject.next(row.id);
    }
    
    onMouseOut(row: any) {
      //console.log("Out row:" +row.id);
      this.mouseoutSubject.next(false);
    }

    ngOnDestroy(): void {
      this.deliveryOpAndSlotSubscription.unsubscribe();
    }
    

}
